// @flow
import {
    borderRadius,
    controlPanelHeight,
    detailsPadding,
    iconsContainerHeight,
    marginDesktop,
    marginMobile,
    marginTablet,
    textContainerHeight
} from '../style-variables';
import styled, { keyframes } from 'styled-components';

import { lighten, transparentize } from 'polished';
import DeviceIcon from '~/core/icons/device-icon';
import Icon from '~/core/icons';
import { media } from '~/core/utils/style';

const iconSizeFactor = 0.5;
const controlPanelIconSize = 2.2;

const arrowWidth = 10;

const animOpacity = keyframes`
	from { opacity: 0; }
	to { opacity: 1; }
`;

const bezier = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const RecipeItem = styled.div`flex: 1 0 20em;`;

export const Content = styled.div`
    border-radius: ${borderRadius}em;
    margin: ${marginMobile}em;
    position: relative;
    transition: box-shadow 0.3s;

    ${media.tablet`margin: ${marginTablet}em;`} ${media.desktop`margin: ${marginDesktop}em;`} &:hover {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
    }
`;

export const IconsContainer = styled.div`
    display: flex;
    height: ${iconsContainerHeight}em;
`;

export const Producer = styled.div`
    align-items: center;
    background-color: ${p => (p.isEnabled ? p.theme.mainBrandColor : p.theme.heavyGrey)};
    border-top-left-radius: ${borderRadius}em;
    color: ${p => p.theme.white};
    display: flex;
    flex-basis: calc(50% - ${arrowWidth / 2}px); /* This is for IE11*/
    flex: 0 0 calc(50% - ${arrowWidth / 2}px);
    justify-content: center;
`;

export const Consumer = styled.div`
    align-items: center;
    background-color: ${p => lighten(0.1, p.isEnabled ? p.theme.mainBrandColor : p.theme.heavyGrey)};
    border-top-right-radius: ${borderRadius}em;
    border-bottom: solid ${iconsContainerHeight / 2}em transparent;
    border-left: solid ${arrowWidth}px ${p => (p.isEnabled ? p.theme.mainBrandColor : p.theme.heavyGrey)};
    border-top: solid ${iconsContainerHeight / 2}em transparent;
    color: ${p => p.theme.white};
    display: flex;
    flex-basis: calc(50% + ${arrowWidth / 2}px); /* This is for IE11*/
    flex: 0 0 calc(50% + ${arrowWidth / 2}px);
    justify-content: center;
`;

export const ProductIcon = styled(Icon)`font-size: ${iconsContainerHeight * iconSizeFactor}em;`;

export const ProductDeviceIcon = styled(DeviceIcon)`font-size: ${iconsContainerHeight * iconSizeFactor}em;`;

export const Details = styled.div`
    border: solid 1px ${p => (p.isEnabled ? p.theme.mainBrandColor : p.theme.heavyGrey)};
    border-top: none;
    border-bottom-left-radius: ${borderRadius}em;
    border-bottom-right-radius: ${borderRadius}em;
    padding: ${detailsPadding}em;
`;

export const Text = styled.div`
    height: ${textContainerHeight}em;
    line-height: 1.5em;
`;

export const ControlPanel = styled.div`
    align-items: center;
    display: flex;
    height: ${controlPanelHeight}em;
    justify-content: space-between;
`;

export const ControlPanelIcon = styled(Icon)`
    cursor: pointer;
    font-size: ${controlPanelIconSize}em;
    opacity: ${p => (p.isDisabled ? 0.2 : 1)};
`;

export const ControlPanelToggleButton = styled.div`font-size: ${controlPanelIconSize / 3}em;`;

export const Overlay = styled.div`
    align-items: center;
    background-color: ${p => transparentize(0.2, p.theme.secondaryColor)};
    border-radius: ${p => (p.show ? `${borderRadius}em` : '50%')};
    display: flex;
    height: ${p => (p.show ? '100%' : 0)};
    justify-content: center;
    left: ${p => (p.show ? 0 : '50%')};
    position: absolute;
    top: ${p => (p.show ? 0 : '50%')};
    transition: 0.3s ${bezier};
    width: ${p => (p.show ? '100%' : 0)};
`;

export const OverlayContent = styled.div`
    animation: ${animOpacity} 0.1s ${bezier} forwards;
    animation-delay: 0.3s;
    background-color: white;
    border-radius: ${borderRadius}em;
    max-width: 80%;
    opacity: 0;
    overflow: hidden;
    padding: 0.8em 1em;
    width: auto;

    & > div > button {
        font-size: 0.8em;
        margin: 1em 0.4em 0 0;
        padding: 0.4em 1.2em;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-item/style.js